import { getBaseParams } from './get-base-params';

/**
 * Builds a typed coanalyt event instance by merging base params with the event payload.
 * The payload excludes fields already provided by getBaseParams (displayLanguage, storeId).
 */
export const buildEvent = <TEvent extends new (params: any) => unknown>({
	Event,
	payload = {} as Omit<ConstructorParameters<TEvent>[0], keyof ReturnType<typeof getBaseParams>>,
}: {
	Event: TEvent;
	payload?: Omit<ConstructorParameters<TEvent>[0], keyof ReturnType<typeof getBaseParams>>;
}) => new Event({ ...getBaseParams(), ...payload } as ConstructorParameters<TEvent>[0]);
